'use client';

import { cn } from '@eliadmin/core/src/utils/style-utils';

export function ReferencesSkeleton() {
  return (
    <div className={cn('animate-pulse', 'grid w-full grid-cols-1 gap-6 md:grid-cols-2')}>
      {Array.from({ length: 6 }).map((_, index) => (
        <div
          key={index}
          className="col-span-1 h-[250px] w-full rounded-[8px] bg-neutral-100 sm:h-[300px] md:h-[350px] lg:h-[420px] xl:h-[440px]"
        />
      ))}
    </div>
  );
}
